module.exports = __webpack_public_path__ + "static/media/giovanni-1.acf35416.wav";